<template>
  <el-select
    v-model="userId"
    :placeholder="placeholder"
    @change="valChange"
    clearable
    remote
    :multiple="multiple"
    :remote-method="remoteMethod"
    :loading="loading"
    :size="size"
    filterable>
    <el-option
      v-for="item in employees"
      :key="item.userId"
      :label="item.name"
      :value="item.userId"
    />
  </el-select>
</template>
<script>

import suggestApi from '../../request/suggestApi'

export default {
  name: 'employeeSelector',
  props: {
    warehouseId: {
      type: Number,
      default: 0
    },
    fromUserId: {
      type: Number,
      default: null
    },
    size: {
      type: String,
      default: 'large'
    },
    systemId: {
      type: Number,
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '用户(请输入关键词)'
    }
  },
  data() {
    return {
      employees: [],
      loading: false,
      userId: null
    }
  },
  methods: {
    remoteMethod(keyword) {
      this.loading = true
      this.employees = []
      if (!keyword) {
        this.loading = false
        return
      }
      suggestApi.employeeSuggest(keyword).then(list => {
        this.employees = list
        if (this.systemId !== null && keyword.trim() === '系统') {
          this.employees.unshift({
            userId: this.systemId,
            name: '系统'
          })
        }
        this.loading = false
      }).catch(err => {
        console.log('employeeSuggest err', err)
        this.$message.error(err.message)
        this.loading = false
      })
    },

    valChange(val) {
      if (this.multiple) {
        if (!val || !val.length) {
          this.$emit('employeeChange', val, [])
        } else {
          const empList = this.employees
          const emps = val.map(userId => {
            const index = val ? empList.findIndex(emp => emp.userId === userId * 1) : -1
            return index > -1 ? empList[val] : null
          })
          this.$emit('employeeChange', val, emps)
        }
      } else {
        const empList = this.employees
        const index = val ? empList.findIndex(emp => emp.userId === val * 1) : -1
        const emp = index > -1 ? empList[val] : null
        this.$emit('employeeChange', val, emp)
      }

    }
  },
  mounted() {

  },

  watch: {
    fromUserId: {
      handler: function(newV, oldV) {
        // console.log('fromUserId', newV, oldV)
        if (newV) {
          const empList = this.employees
          const index = empList.findIndex(emp => emp.userId === newV)
          if (index === -1) {
            this.loading = true
            suggestApi.employeeSuggest(newV).then(list => {
              this.employees = list
              this.loading = true
            }).catch(err => {
              this.$message.error(err.message)
              this.loading = false
            })
          }
        }
        this.userId = newV
      },
      immediate: true
    }
  },

  computed: {

  }

}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/EmployeeSelector/index.vue